import React from "react";
import { Link } from "react-router-dom";

// components
import {
  SettingsTopLine,
  SettingsBack1,
  SettingsClose,
} from "./SettingBar.elements";

// icons
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

const SettingBar = ({ setting }) => {
  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  return (
    <>
      <SettingsTopLine>
        {setting.title}
        <SettingsBack1 onClick={handleBackButtonClick}>
          <MdOutlineArrowBackIosNew></MdOutlineArrowBackIosNew>
        </SettingsBack1>

        <Link to="/">
          <SettingsClose>
            <AiOutlineClose></AiOutlineClose>
          </SettingsClose>
        </Link>
      </SettingsTopLine>
    </>
  );
};

export default SettingBar;
